import type { Ref } from 'react'
import { DrawnFrame } from '../ui/DrawnFrame'
import './masthead.css'

/**
 * The masthead an org drew for its public home, drawn in a frame of its own.
 *
 * The page's heading stays in the page: what the frame holds is a separate
 * document to a reader walking the headings. On a home page that heading is
 * the org's name, held for the reader alone; a page with a heading of its own
 * — a fund's — names the masthead's region instead and adds none.
 */
export function Masthead({
  html,
  title,
  ref,
  heading = true,
  bleed = true,
}: {
  html: string
  title: string
  ref?: Ref<HTMLElement>
  /** Whether the masthead carries the page's heading. */
  heading?: boolean
  /** Whether the page runs edge to edge, so the masthead keeps its own
   *  measure; on a page held to the measure already it fills that. */
  bleed?: boolean
}) {
  const frameEl = <DrawnFrame html={html} title={title} />
  return (
    <section
      className="masthead"
      aria-labelledby={heading ? 'home-hero' : undefined}
      aria-label={heading ? undefined : title}
      ref={ref}
    >
      {heading ? (
        <h1 id="home-hero" className="sr-only">
          {title}
        </h1>
      ) : null}
      {bleed ? <div className="home__measure">{frameEl}</div> : frameEl}
    </section>
  )
}
